import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

import Card from '@intec/vue-components/form/Card.vue';
import { useProcedureStageComponentStore } from '@/stores/procedureStageComponentStore';
import { useDialogStore } from '@/stores/dialog';
import { computed, ref } from 'vue';
import api from '@/api';
import { toast } from '@/lib/toast';

interface Props {
  procedure: {
    Object,
    required: true,
  },
  onSuccess: () => Promise<void>,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProcedureReturnToPublished',
  props: {
    procedure: {},
    onSuccess: { type: Function, default: async () => {} }
  },
  setup(__props: any) {

const props = __props;

const { id, registryNumber, typeCode } = props.procedure;

const { closeDialog } = useDialogStore();

const stages = ref(null);

const procedure = ref({
  reacceptanceExplanation: null,
});
const errors = ref({});

const pickersDisabledDate = (date) => date < new Date(new Date().setHours(0, 0, 0, 0));

const stageStore = useProcedureStageComponentStore();
const stageComponent = computed(() => {
  return stageStore.getComponentByType(typeCode);
});

const approve = async () => {
  if (stages.value.validate && !(await stages.value.validate())) {
    return;
  }
  const formData = new FormData();
  formData.append('step', 'published');
  formData.append('data', JSON.stringify(procedure.value));
  try {
    await api.post(`/procedures/${id}/returnToStep`, formData);
    toast.info('Процедура возвращена успешно');
    await props.onSuccess();
    closeDialog();
  } catch (e) {
    toast.error(e.message);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!

  return (_openBlock(), _createBlock(Card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "pa-0" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Возврат процедуры № {_1} на стадию "Приём заявок"', { '_1': _unref(registryNumber) })), 1 /* TEXT */),
          _createVNode(_component_v_icon, {
            class: "close-button",
            onClick: _unref(closeDialog)
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("mdi-close")
            ])),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_v_card_subtitle, { class: "px-0" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Определите параметры проведения процедуры')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      (stageComponent.value)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(stageComponent.value), {
            key: 0,
            ref_key: "stages",
            ref: stages,
            class: "stages",
            procedure: procedure.value,
            errors: errors.value,
            "only-dates": true,
            "append-to-body": false,
            "disabled-date": pickersDisabledDate
          }, null, 8 /* PROPS */, ["procedure", "errors"]))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_v_card_subtitle, { class: "px-0" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Приём заявок начнётся сразу после возврата процедуры')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", null, [
        _createVNode(_component_v_textarea, {
          rows: 3,
          maxlength: "2000",
          modelValue: procedure.value.reacceptanceExplanation,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((procedure.value.reacceptanceExplanation) = $event)),
          variant: "outlined",
          "hide-details": "",
          placeholder: _ctx.$t('Укажите информацию о причинах возврата процедуры')
        }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
      ]),
      _createVNode(_component_v_card_actions, { class: "flex-row pa-0 py-1 pb-1" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "elevated",
            onClick: approve,
            class: "action-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Опубликовать')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})